import { textColors } from 'ui/theme';

// Icons are passed a color from segmented control component depending on if the option is selected or not
export const isOptionSelected = (color: string = '') => color !== textColors.textSecondary;

// This returns either the correct color if the control isn't selected or a customized color if it is
export const getIconColor = (iconColor: string, propColor: string = '') => {
  if (isOptionSelected(propColor)) {
    return iconColor;
  }
  return propColor;
};
